import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/calculate-payrolls', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/calculate-payrolls', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default { get, store }
